import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import ClinicProfile from "../components/ClinicProfile";
import ProviderList from "../components/ProviderList";
import ClinicStripeOnboarding from "../components/ClinicStripeOnboarding";
import { SERVER_URL } from "../config";
import "../styles/clinicContainer.css";
import { ClinicManager } from "../types/clinic"; // ✅ shared type
import useCurrentUser from "../hooks/useCurrentProvider";

const ClinicContainer: React.FC = () => {
  const { isClinic } = useCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();
  const passedClinic = location.state?.clinic as ClinicManager | undefined;

  const [clinicData, setClinicData] = useState<ClinicManager | null>(
    passedClinic || null
  );
  const [loading, setLoading] = useState<boolean>(!passedClinic);
  const [error, setError] = useState<string | null>(null);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (clinicData) return;

    const fetchClinic = async () => {
      try {
        const url = `${SERVER_URL}/api/clinic/profile`;

        const response = await fetchWithAuth(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        setClinicData(data);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchClinic();
  }, [clinicData, token]);

  if (loading) return <p>Loading clinic information...</p>;
  if (!isClinic) {
    navigate("/");
  }
  if (error) return <p>Error: {error}</p>;
  if (!clinicData) return <p>No clinic data found.</p>;

  console.log({ clinicData });

  return (
    <div className="clinic-container">
      <div className="section">
        <ClinicProfile clinicData={clinicData} />
      </div>
      {/* <div className="section"> */}
      <ClinicStripeOnboarding
        clinic={clinicData.clinic}
        clinicId={clinicData.clinicId}
      />
      {/* </div> */}
      {clinicData.clinic?.providers?.length > 0 && (
        <div className="section">
          <ProviderList providers={clinicData.clinic.providers} />
        </div>
      )}
    </div>
  );
};

export default ClinicContainer;
